import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasivoService {

  constructor(private http: HttpClient) { }

  cargarMasivos(formData: FormData): Observable<any> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*'
    });
    return this.http.post(
      `${environment.API_REST_URL}/uploadFileMasivo`, 
      formData, 
      { headers }
    );
  }
}
